import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { CSP_NONCE, importProvidersFrom, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule, NoopAnimationsModule, provideNoopAnimations } from '@angular/platform-browser/animations';
import { PcmmaterialModule } from './pcmmaterial/pcmmaterial.module';
import { AppInterceptor } from './global/app-interceptor';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HTTP_INTERCEPTORS,provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { NgxSpinnerModule } from 'ngx-spinner';

// checks if the app is running on IE

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
	   storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set(environment.BASE_API_URL+'*', environment.apiConfig.scopes);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes]
    },
    loginFailedRoute: '/'
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
imports: [
  NgxSpinnerModule,
        NgxChartsModule,
        MsalModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        PcmmaterialModule,
        NoopAnimationsModule,
        MsalModule.forRoot(
          new PublicClientApplication({
            auth: {
                clientId: environment.clientId,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: isIE,
            },
        }),
         {
            interactionType: InteractionType.Redirect,
            authRequest: {
                scopes: ["user.read"],
            },
        },
         {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: new Map([
                ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
            ]),
        }
      ),
    ],
     providers: [
        provideClientHydration(),
        importProvidersFrom(BrowserModule),
        provideNoopAnimations(),
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        // { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        {
            provide: CSP_NONCE,
            useValue: "9+EESzFcGU2jLYNVO/U4+DGT8xNk4iKbkeEC1i1XulI="
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService
        ,provideHttpClient(withInterceptorsFromDi())
    ],
      bootstrap: [AppComponent]
    })
export class AppModule { }

